
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Mutation, State } from "vuex-class";

const autoFeedEnabledMessage = "Auto Feed Enabled: Closing this event will take you to the next in the queue";
const autoFeedDisabledMessage = "Auto Feed Disabled: Closing this event will take you back to the queue";

@Component
export default class AutoFeedAlarms extends Vue {
	@State autoFeedAlarms: boolean;
	@Mutation toggleAutoFeedAlarms: () => void;

	private toggleAutoFeed(): void {
		this.toggleAutoFeedAlarms();
	}

	private get autoFeedVariantProp(): string {
		return this.autoFeedAlarms ? "primary" : "secondary";
	}

	private get autoFeedTooltipMessage(): string {
		return this.autoFeedAlarms ? autoFeedEnabledMessage : autoFeedDisabledMessage;
	}
}
